import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function Hero() {
  return (
    <div className="ws-hero">
      <Container>
        <Row className="align-items-center">
          <Col lg={7}>
            <div className="ws-eyebrow">Premium Quality</div>
            <h1>Discover Your Perfect Hair Transformation</h1>
            <p>
              Premium quality wigs crafted with care. From natural looks to bold statements,
              find the perfect style that makes you feel confident and beautiful.
            </p>
            <div className="ws-actions">
              <Link to="/#products" className="ws-btn ws-btn-primary">Shop Now</Link>
              <Link to="/#collection" className="ws-btn ws-btn-outline">View Collection</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Hero


